export const TAGS_BATCH_SIZE = 25;